import _ from 'underscore';
import {
 ApiHotelOffer, TourProduct, FirstPaymentDefinition,
} from '@ve/types';
import matchFirstPaymentDefinitionsByIds
    from '@/js/common/Domain/Service/searchTour/service/apiTourToTourAdapter/matchFirstPaymentDefinitionsByIds';
import apiHotelOfferToHotelOfferAdapter from '../searchTour/service/apiHotelOfferToHotelOfferAdapter';

export default ({
hotelOffers, firstPaymentDefinitions,
}: {
    hotelOffers: ApiHotelOffer[],
    firstPaymentDefinitions: FirstPaymentDefinition[]
}): any[] => {
    const firstPaymentDefinitionsKeys = _.indexBy(firstPaymentDefinitions, 'id');

    return _.map(hotelOffers, (hotelOffer) => apiHotelOfferToHotelOfferAdapter({
        ...hotelOffer,
        firstPaymentDefinitions: matchFirstPaymentDefinitionsByIds({
            firstPaymentDefinitionIds: hotelOffer.firstPaymentDefinitions,
            firstPaymentDefinitionReferenceIndex: firstPaymentDefinitionsKeys,
        }),
    }));
};
